import script from "./Tabs.vue?vue&type=script&setup=true&lang=ts"
export * from "./Tabs.vue?vue&type=script&setup=true&lang=ts"

import "./Tabs.vue?vue&type=style&index=0&id=ce57a204&lang=css"

const __exports__ = script;

export default __exports__
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QTabs,QTab});
